function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", null);

var _ref3 = /*#__PURE__*/React.createElement("g", null);

var _ref4 = /*#__PURE__*/React.createElement("g", null);

var _ref5 = /*#__PURE__*/React.createElement("g", null);

var _ref6 = /*#__PURE__*/React.createElement("g", null);

var _ref7 = /*#__PURE__*/React.createElement("g", null);

var _ref8 = /*#__PURE__*/React.createElement("g", null);

var _ref9 = /*#__PURE__*/React.createElement("g", null);

var _ref10 = /*#__PURE__*/React.createElement("g", null);

var _ref11 = /*#__PURE__*/React.createElement("g", null);

var _ref12 = /*#__PURE__*/React.createElement("g", null);

var _ref13 = /*#__PURE__*/React.createElement("g", null);

var _ref14 = /*#__PURE__*/React.createElement("g", null);

var _ref15 = /*#__PURE__*/React.createElement("g", null);

var _ref16 = /*#__PURE__*/React.createElement("g", null);

function Svg018DominicanRepublic(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    id: "Capa_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512.006 512.006",
    style: {
      enableBackground: "new 0 0 512.006 512.006"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("rect", {
    x: 0.003,
    y: 0.017,
    style: {
      fill: "#F0F0F0"
    },
    width: 512,
    height: 511.989
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.003,
    y: 322.794,
    style: {
      fill: "#D80027"
    },
    width: 211.478,
    height: 189.206
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.003,
    style: {
      fill: "#0052B4"
    },
    width: 211.478,
    height: 189.229
  }), /*#__PURE__*/React.createElement("rect", {
    x: 300.525,
    style: {
      fill: "#D80027"
    },
    width: 211.478,
    height: 189.229
  }), /*#__PURE__*/React.createElement("rect", {
    x: 300.525,
    y: 322.794,
    style: {
      fill: "#0052B4"
    },
    width: 211.478,
    height: 189.206
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#496E2D"
    },
    d: "M320.003,256.006c0,35.347-28.653,64-64,64c-35.346,0-64-28.653-64-64s64-64,64-64  S320.003,220.659,320.003,256.006z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#0052B4"
    },
    d: "M192.003,256.006c0-35.347,28.654-64,64-64c35.347,0,64,28.653,64,64"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D80027"
    },
    d: "M220.003,224.006v40.001c0,19.882,16.118,36,36,36s36-16.118,36-36v-40.001L220.003,224.006  L220.003,224.006z"
  }), _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(Svg018DominicanRepublic);
export default "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iaXNvLTg4NTktMSI/Pgo8IS0tIEdlbmVyYXRvcjogQWRvYmUgSWxsdXN0cmF0b3IgMTkuMC4wLCBTVkcgRXhwb3J0IFBsdWctSW4gLiBTVkcgVmVyc2lvbjogNi4wMCBCdWlsZCAwKSAgLS0+CjxzdmcgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB4bWxuczp4bGluaz0iaHR0cDovL3d3dy53My5vcmcvMTk5OS94bGluayIgdmVyc2lvbj0iMS4xIiBpZD0iQ2FwYV8xIiB4PSIwcHgiIHk9IjBweCIgdmlld0JveD0iMCAwIDUxMi4wMDYgNTEyLjAwNiIgc3R5bGU9ImVuYWJsZS1iYWNrZ3JvdW5kOm5ldyAwIDAgNTEyLjAwNiA1MTIuMDA2OyIgeG1sOnNwYWNlPSJwcmVzZXJ2ZSI+CjxyZWN0IHg9IjAuMDAzIiB5PSIwLjAxNyIgc3R5bGU9ImZpbGw6I0YwRjBGMDsiIHdpZHRoPSI1MTIiIGhlaWdodD0iNTExLjk4OSIvPgo8cmVjdCB4PSIwLjAwMyIgeT0iMzIyLjc5NCIgc3R5bGU9ImZpbGw6I0Q4MDAyNzsiIHdpZHRoPSIyMTEuNDc4IiBoZWlnaHQ9IjE4OS4yMDYiLz4KPHJlY3QgeD0iMC4wMDMiIHN0eWxlPSJmaWxsOiMwMDUyQjQ7IiB3aWR0aD0iMjExLjQ3OCIgaGVpZ2h0PSIxODkuMjI5Ii8+CjxyZWN0IHg9IjMwMC41MjUiIHN0eWxlPSJmaWxsOiNEODAwMjc7IiB3aWR0aD0iMjExLjQ3OCIgaGVpZ2h0PSIxODkuMjI5Ii8+CjxyZWN0IHg9IjMwMC41MjUiIHk9IjMyMi43OTQiIHN0eWxlPSJmaWxsOiMwMDUyQjQ7IiB3aWR0aD0iMjExLjQ3OCIgaGVpZ2h0PSIxODkuMjA2Ii8+CjxwYXRoIHN0eWxlPSJmaWxsOiM0OTZFMkQ7IiBkPSJNMzIwLjAwMywyNTYuMDA2YzAsMzUuMzQ3LTI4LjY1Myw2NC02NCw2NGMtMzUuMzQ2LDAtNjQtMjguNjUzLTY0LTY0czY0LTY0LDY0LTY0ICBTMzIwLjAwMywyMjAuNjU5LDMyMC4wMDMsMjU2LjAwNnoiLz4KPHBhdGggc3R5bGU9ImZpbGw6IzAwNTJCNDsiIGQ9Ik0xOTIuMDAzLDI1Ni4wMDZjMC0zNS4zNDcsMjguNjU0LTY0LDY0LTY0YzM1LjM0NywwLDY0LDI4LjY1Myw2NCw2NCIvPgo8cGF0aCBzdHlsZT0iZmlsbDojRDgwMDI3OyIgZD0iTTIyMC4wMDMsMjI0LjAwNnY0MC4wMDFjMCwxOS44ODIsMTYuMTE4LDM2LDM2LDM2czM2LTE2LjExOCwzNi0zNnYtNDAuMDAxTDIyMC4wMDMsMjI0LjAwNiAgTDIyMC4wMDMsMjI0LjAwNnoiLz4KPGc+CjwvZz4KPGc+CjwvZz4KPGc+CjwvZz4KPGc+CjwvZz4KPGc+CjwvZz4KPGc+CjwvZz4KPGc+CjwvZz4KPGc+CjwvZz4KPGc+CjwvZz4KPGc+CjwvZz4KPGc+CjwvZz4KPGc+CjwvZz4KPGc+CjwvZz4KPGc+CjwvZz4KPGc+CjwvZz4KPC9zdmc+Cg==";
export { ForwardRef as ReactComponent };